import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import WeekDays from './WeekDays';
import FromTo from './FromTo';

import { Text, Spacer } from '@ontruck/orc';

const t = {
  title: 'Repeats on',
  edit_create_cancel: 'Editing this time range will create or cancel orders when necessary',
};

class RepeatsOn extends PureComponent {
  render() {
    const { schedule } = this.props;

    return (
      <div>
        <Spacer mRight="XS" mBottom="S">
          <Text size="XL" weight="bold">
            {t.title}
          </Text>
        </Spacer>
        <Spacer mTop="S" mBottom="S">
          <WeekDays schedule={schedule} />
        </Spacer>
        <Spacer mTop="S" mBottom="S">
          <FromTo />
        </Spacer>
        <Spacer mRight="XS" mTop="S" mBottom="S">
          <Text text={t.edit_create_cancel} size="M" color="greyWolf" />
        </Spacer>
      </div>
    );
  }
}

RepeatsOn.propTypes = {
  schedule: PropTypes.arrayOf(PropTypes.number).isRequired,
};

export default RepeatsOn;
